import classNames from 'classnames';
import React, { memo, ReactNode } from 'react';
import { useWindowHeight } from '../helpers/hooks';
import Modal, { ModalProps } from './Modal';

export const LIGHT_BOX = 'LIGHT_BOX';

type LightBoxProps = ModalProps & {
  headerTitle?: string;
  headerDescription?: string;
  headerColor?: string;
  content?: ReactNode;
  useBack?: boolean;
  onClose: () => void;
};

const LightBox = ({
  onClose,
  headerTitle = '',
  headerDescription = '',
  headerColor,
  content = null,
  useBack = false,
  ...restProps
}: LightBoxProps) => {
  const windowHeight = useWindowHeight();
  return (
    <Modal
      overlayClassName="justify-end"
      className={{
        base: classNames(
          useBack ? 'translate-x-9/10' : 'translate-y-9/10',
          'transition-transform md:translate-x-9/10'
        ),
        afterOpen: classNames(
          useBack ? 'translate-x-none' : 'translate-y-none',
          'md:translate-x-none'
        ),
        beforeClose: classNames(
          useBack ? 'translate-x-full' : 'translate-y-full',
          'md:translate-x-full'
        )
      }}
      contentStyle={{
        width: '100%',
        maxWidth: '450px',
        // overflowY: 'scroll',
        height: `${windowHeight}px`,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}
      {...restProps}
      closeTimeoutMS={250}
      onRequestClose={onClose}
    >
      <Modal.Header
        title={headerTitle}
        description={headerDescription}
        onClose={onClose}
        color={headerColor}
      />
      {content}
    </Modal>
  );
};

export default memo(LightBox);
